import Model from '@/models/Model'

export default class SlWholesaleDiscount extends Model {
    resource() {
        return 'sl_wholesale_discount'
    }
}